import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';
import { SettingsRequest } from '../api/settings/settingsrequest';
import { SettingsResponse, SettingsResponseDtoImpl } from '../api/settings/settingsresponse';

export class SettingsAPIProcessorImpl extends APIProcessorImpl<SettingsRequest, SettingsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SettingsAPIProcessorImpl.name);
     execute(request: SettingsRequest): void
    {
        super.execute(request);
    }
      /* execute()
     {
         console.log("execute() in SettingsAPIProcessorImpl"); 

         let passwordValidationResponse = new SettingsResponseDtoImpl(APIFeatures.SETTINGS, "Valid Password");
        
         let responseMapDto = new ResponseMapDtoImpl();
         responseMapDto.setAccessToken("1e3a077e-445a-40ac-baf3-f8ee50767bc4");
         responseMapDto.setRefreshToken("b74628e1-8457-4f2c-9d92-1bed00bbfcd2");
         responseMapDto.setDeviceId("1");
         responseMapDto.setExpiry(800000);
         passwordValidationResponse.setMessage("Success");
         passwordValidationResponse.setRespTime("Apr 8, 2020 12:15:07 PM");
         passwordValidationResponse.setStatusCode("SC0000");
         passwordValidationResponse.setResponseMap(responseMapDto);
         passwordValidationResponse.setSettings("\"settings\":{}");
             
         this.getAPISuccess(passwordValidationResponse);
     }  */
    /*  "accessToken": "1e3a077e-445a-40ac-baf3-f8ee50767bc4",
    "refreshToken": "b74628e1-8457-4f2c-9d92-1bed00bbfcd2",
     "msisdn": "0504843969",
     "deviceId": "67c49626-558d-486a-abbb-5e035ae41b8e",
     "expiry": 600000, */
     onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            this.LOGGER.log("onSuccess() invoked : "+responseMapper.getStatusCode());
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new SettingsResponseDtoImpl(APIFeatures.SETTINGS , "Valid Password");

                let responseMap = responseMapper.getResponseMap();
               
                this.getContext().setConfigurationSettings(JSON.parse(JSON.stringify(responseMap.settings)).others);
              
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
           
                this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.FAILURE, responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/settingsapiprocessor.tsx